// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Acquisition Store API
 * API for managing acquisition in-store.
 * OpenAPI spec version: 1.0.0
 */

/**
 * Name of the event, carried in the SSE `event:` field. Always equal to `data.event`.
 *
 * Possible values:
 * - connected (CONNECTED)
 * - heartbeat (HEARTBEAT)
 * - presence.changed (PRESENCE_CHANGED)
 * - file.created (FILE_CREATED)
 * - file.removed (FILE_REMOVED)
 * - barcode.scanned (BARCODE_SCANNED)
 * - offer.source-changed (OFFER_SOURCE_CHANGED)
 * - offer.created (OFFER_CREATED)
 * - offer.display-changed (OFFER_DISPLAY_CHANGED)
 * - offer.display-updated (OFFER_DISPLAY_UPDATED)
 * - offer.display-receipt-changed (OFFER_DISPLAY_RECEIPT_CHANGED)
 */
export type CompanionSseEvent = typeof CompanionSseEvent[keyof typeof CompanionSseEvent];


export const CompanionSseEvent = {
  CONNECTED: 'connected',
  HEARTBEAT: 'heartbeat',
  PRESENCE_CHANGED: 'presence.changed',
  FILE_CREATED: 'file.created',
  FILE_REMOVED: 'file.removed',
  BARCODE_SCANNED: 'barcode.scanned',
  OFFER_SOURCE_CHANGED: 'offer.source-changed',
  OFFER_CREATED: 'offer.created',
  OFFER_DISPLAY_CHANGED: 'offer.display-changed',
  OFFER_DISPLAY_UPDATED: 'offer.display-updated',
  OFFER_DISPLAY_RECEIPT_CHANGED: 'offer.display-receipt-changed',
} as const;
